import * as React from "react"
import useFormaters from "../Hooks/useFormatters"

type StatisticNumber = {
	value?: number
	decimals?: number
	spaceBetween?: boolean
}

const StatisticNumber = (props: StatisticNumber) => {
	const { value, decimals, spaceBetween } = props
	const { formatNumber } = useFormaters()

	if (!value) return null

	return <>{formatNumber(value, { decimals, spaceBetween })}</>
}

export default StatisticNumber
